import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from './Context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider>
        <App />
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
